/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useRef} from "react";
import {Button} from "react-bootstrap";
import {GlyphButton} from "../../../Components/Common/ButtonWithIcon";

export const ImageUploadFieldEditor = (props) => {
	const {
		Value,
		OnUpdate
	} = props;
	const inputField = useRef(null);

	const displayDialog = () => {
		inputField?.current?.click?.();
	};

	const onFileSelect = (e) => {
		const reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = () => {
			OnUpdate(reader.result);
		};
	};

	const deleteCurrent = () => {
		inputField.current.value = null;
		OnUpdate(null);
	};

	return <div className="sb-single-line-with-button-field-editor">
		<div className="pndlm-image-editor-preview">
			{Value ? <img src={Value} alt=""/> : null}
		</div>

		<Button
			className="pndlm-image-upload-button pndlm-button-grey"
		onClick={displayDialog}
		>
			Upload
		</Button>

		<input
			style={{display: "none"}}
		ref={inputField}
			type="file"
		onChange={onFileSelect}
			onClick={() => {
				inputField.current.value = null; /* this ensures onChange is triggered for the same file */
			}}
			multiple={false}
		/>

		<GlyphButton
			className="pndlm-image-delete-reset-button"
			glyph="remove-sign"
		onClick={deleteCurrent}
		>
			Delete
		</GlyphButton>
	</div>;
};